import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import FlagIcon from 'vue-flag-icon';

import i18n from './plugins/i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import RevampAPI from './services/revampApi';

// scroll plugins
import './plugins/vpshowScroll';

// Bootstrap
Vue.use(BootstrapVue);
Vue.use(FlagIcon);

// Init Revamp API Service
RevampAPI.init(process.env.VUE_APP_REVAMP_API, process.env.VUE_APP_REVAMP_API_TOKEN);

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
